module.exports = __webpack_public_path__ + "static/img/quanweijiedu.a4126cb6.png";